import { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useTranslatedStaticPage = (page: string) => {
  const [content, setContent] = useState<string>('');

  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    if (!i18n || !i18n.language) return;

    fetch(`/pages/${page}/${i18n.language}.html`)
      .then((response) => {
        if (!response.ok) throw new Error('Something went wrong');
        return response;
      })
      .then((response) => response.text())
      .then(setContent)
      .catch(() => {
        fetch(`/pages/${page}/en.html`)
          .then((response) => response.text())
          .then(setContent);
      });
  }, [i18n, i18n.language]);

  return { content };
};
